// extracted by mini-css-extract-plugin
export var activeTitleClassName = "TreatmentDetailsFooter-module--activeTitleClassName--22d14";
export var borderHeading = "TreatmentDetailsFooter-module--borderHeading--ea0d9";
export var cardContentStyling = "TreatmentDetailsFooter-module--cardContentStyling--d7196";
export var cardTitleStyling = "TreatmentDetailsFooter-module--cardTitleStyling--8e485";
export var contentAccordionCardStyling = "TreatmentDetailsFooter-module--contentAccordionCardStyling--4f1ac";
export var contentCardStyling = "TreatmentDetailsFooter-module--contentCardStyling--2a443";
export var contentCardsContainer = "TreatmentDetailsFooter-module--contentCardsContainer--abe03";
export var contentCardsStyling = "TreatmentDetailsFooter-module--contentCardsStyling--8d09f";
export var headerStyling = "TreatmentDetailsFooter-module--headerStyling--6c8aa";
export var titleClassName = "TreatmentDetailsFooter-module--titleClassName--dcb51";